import { useCallback } from 'react';
import * as Role from '../../../../constants/role';
import { isDigitacaoHabilitada } from '../../../../helpers/digitacaoAntecipada';
import { pickDigitacaoUsoMutuoPayload } from '../utils/pickDigitacaoUsoMutuoPayload';
import {
  isAnaliseRiscoOrFotoRegistro,
  isUsoMutuoEvidenciaCampo,
  isUsoMutuoSucataRow,
} from '../utils/nsmpRowTypes';

const isPosteDigitacao = (data) =>
  Boolean(data?.id)
  && !isUsoMutuoSucataRow(data)
  && !isUsoMutuoEvidenciaCampo(data)
  && !isAnaliseRiscoOrFotoRegistro(data);

/**
 * Decide PATCH digitacao-uso-mutuo vs PUT completo.
 * Digitador nunca envia o NSMP inteiro no overlay nem em EM_DIGITACAO.
 */
export const useUsoMutuoSave = ({
  nsirStatus,
  digitadorId,
  userId,
  userRole,
  nsirId,
  digitacaoAntecipada,
  digitarNsmpUsoMutuo,
  updateNsmp,
  saveNsmp,
  onSuccess,
  onReatribuida,
}) => {
  const shouldUsePatch = useCallback(
    (data) =>
      isPosteDigitacao(data)
      && isDigitacaoHabilitada({
        status: nsirStatus,
        digitadorId,
        userId,
        userRole,
        digitacaoAntecipada,
      })
      && userRole === Role.DIGITADOR,
    [nsirStatus, digitadorId, userId, userRole, digitacaoAntecipada],
  );

  const savePayload = useCallback(
    (data, { advanceNext } = {}) => {
      const afterSuccess = (ok, result, statusCode) => {
        if (statusCode === 409) {
          onReatribuida?.(result);
          return;
        }
        if (ok) {
          onSuccess?.(result, { advanceNext });
        }
      };

      if (shouldUsePatch(data)) {
        digitarNsmpUsoMutuo({
          ...pickDigitacaoUsoMutuoPayload(data),
          nsirId,
          callback: afterSuccess,
        });
        return;
      }

      const payload = { ...data, nsirId };
      if (data?.id) {
        updateNsmp(payload, afterSuccess);
      } else if (data) {
        saveNsmp(payload, afterSuccess);
      }
    },
    [
      shouldUsePatch,
      digitarNsmpUsoMutuo,
      updateNsmp,
      saveNsmp,
      nsirId,
      onSuccess,
      onReatribuida,
    ],
  );

  return { shouldUsePatch, savePayload };
};

export default useUsoMutuoSave;
